import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  body?: string;
  action?: React.ReactNode;
  size?: 'sm' | 'md';
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, body, action, size = 'md' }) => {
  const theme = useTheme();
  const iconSize = size === 'sm' ? 32 : 44;
  const ringSize = size === 'sm' ? 56 : 80;
  const verticalPad = size === 'sm' ? 4 : 8;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        py: verticalPad,
        px: 2,
      }}
    >
      {icon && (
        <Box
          sx={{
            width: ringSize,
            height: ringSize,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            color: theme.palette.primary.main,
            '& > svg': { fontSize: iconSize },
          }}
        >
          {icon}
        </Box>
      )}
      <Typography variant={size === 'sm' ? 'subtitle1' : 'h6'} sx={{ mb: body ? 0.5 : 0 }}>
        {title}
      </Typography>
      {body && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 360, mb: action ? 2 : 0 }}
        >
          {body}
        </Typography>
      )}
      {action}
    </Box>
  );
};

export default EmptyState;
